import React from "react";
import { useNavigate, useParams } from "react-router-dom";

import { TwoButtonModal } from "../../../components/Modals";
import { ViewWorkflowHeader } from "./ViewWorkflowHeader";
import { RunsTable } from "./RunsTable";
import { useWorkflowData } from "./useWorkflowData";
import { ScheduledWorkflowsTable } from "./ScheduledWorkflowsTable";
import NavBanner from "../../../components/Banners/NavBanner";
import { useDialog } from "../../../contexts/DialogContext";

export default function ViewWorkflow() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const { openDialog, closeDialog } = useDialog();

  const {
    workflow,
    isLoading,
    runs,
    scheduledWorkflows,
    isScheduled,
    deleteWorkflow,
  } = useWorkflowData(slug);

  const handleAddNewContextObject = () => {
    navigate(`/workflows/${slug}/scheduled/manage`);
  };

  const handleDelete = () => {
    openDialog(
      <TwoButtonModal
        titleText="Delete workflow"
        bodyText="Are you sure you want to delete this workflow? This action cannot be undone."
        actionText="Delete"
        cancelText="Cancel"
        onAction={() => {
          deleteWorkflow(workflow.id);
          closeDialog();
        }}
        onCancel={closeDialog}
        variant="danger"
      />
    );
  };

  return (
    <>
      <NavBanner />

      {/* note: add max-w-5xl here to be consistent with other views */}
      <div className="pt-6">
        <ViewWorkflowHeader
          workflow={workflow}
          isLoading={isLoading}
          onDelete={handleDelete}
          isScheduled={isScheduled}
          onAddNewContextObject={handleAddNewContextObject}
        />

        {runs ? (
          <RunsTable workflow={workflow} runs={runs} />
        ) : scheduledWorkflows ? (
          <ScheduledWorkflowsTable
            workflowId={slug}
            scheduledWorkflows={scheduledWorkflows}
          />
        ) : null}
      </div>
    </>
  );
}
